import { FiltroData } from "./filtro-data.model";

export class Filtro {
    quantidadePorPargina:number = 12;
    paginas:number;
    pagina:number = 1;
    totalDeRegistros:number;
    dataIntinerario:string;
    dados: FiltroData = new FiltroData();
  }